exports.params = {
    server_path: "http://girudo.info"
}

//server_path: "http://girudo.info"
//server_path: "http://localhost:3000"
//server_path: "http://185.241.4.124:3032"